import React from 'react';

// Riga azione fantasma stile Notion, condivisa fra PartnerPortalAccessDetails e
// ProjectsPortalAccessDetails (era duplicata identica nei due file).
export interface GhostActionProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
  title?: string;
}

export function GhostAction({ icon, label, onClick, disabled, danger, title }: GhostActionProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`inline-flex items-center gap-1.5 px-1.5 py-1 rounded text-xs text-[#787774] dark:text-gray-400 hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/[0.06] disabled:opacity-50 disabled:cursor-default ${
        danger ? 'hover:text-[#D44C47] dark:hover:text-[#E8827D]' : 'hover:text-[#37352F] dark:hover:text-white'
      }`}
    >
      {icon}
      {label}
    </button>
  );
}
